// assets/bot_menu_animation.js
gsap.registerPlugin(SplitText, TextPlugin);

const splits = new WeakMap();

/**
 * DETECT SHOPIFY EDITOR
 * Returns true if we are inside the Theme Editor iframe or design mode.
 */
function isShopifyEditor() {
  try {
    return (
      (window.Shopify && window.Shopify.designMode) ||
      document.documentElement.classList.contains("shopify-design-mode") ||
      window.location.search.indexOf("design_mode=true") > -1 ||
      window.location.search.indexOf("preview_theme_id") > -1 ||
      window.top !== window.self
    );
  } catch (e) {
    return false;
  }
}

function showText(el, delay, direction = "right") {
  const element = typeof el === "string" ? document.querySelector(el) : el;

  // --- EDITOR MODE: Do nothing (render standard text) ---
  if (isShopifyEditor()) {
    element.style.opacity = "1";
    element.style.transform = "none";
    element.style.pointerEvents = "auto";
    return;
  }
  // -----------------------------------------------------

  const existingSplit = splits.get(element);
  if (existingSplit) existingSplit.revert();

  element.innerText = decodeHTMLEntities(element.innerHTML);

  const split = SplitText.create(element, { type: "chars" });
  splits.set(element, split);
  
  // Make sure clicks pass through the animated characters
  if (split.elements) split.elements.forEach(e => e.style.pointerEvents = "none");
  split.chars.forEach((c) => (c.style.pointerEvents = "none"));
  element.style.pointerEvents = "auto";

  const chars = direction === "right" ? split.chars : split.chars.reverse();
  const startColor = getComputedStyle(chars[0]).color;
  const staggerTime = 0.015;
  const offsetX = direction === "right" ? 500 : -500;

  chars.forEach((char, i) => {
    const tl = gsap.timeline({ delay: i * staggerTime });
    tl.fromTo(
      char,
      { x: offsetX, opacity: 0 },
      {
        delay,
        x: 0,
        opacity: 1,
        color: "#ECA6E9",
        textAlign: direction,
        ease: "power4.inOut",
        duration: 0.5,
      }
    )
      .to(char, {
        rotationX: 180,
        rotationY: 180,
        scale: 1.2,
        transformOrigin: "50% 50%",
        yoyo: true,
        repeat: 1,
        duration: 0.02,
        ease: "power1.inOut",
      })
      .to(char, {
        color: startColor,
        duration: 0.02,
        ease: "power1.inOut",
      });
  });
}

function hideText(el, delay, direction = "right") {
  const element = typeof el === "string" ? document.querySelector(el) : el;

  // --- EDITOR MODE: Do nothing ---
  if (isShopifyEditor()) return;
  // -------------------------------

  const existingSplit = splits.get(element);
  if (existingSplit) existingSplit.revert();

  element.innerText = decodeHTMLEntities(element.innerHTML);

  const split = SplitText.create(element, { type: "chars" });
  splits.set(element, split);

  if (split.elements) split.elements.forEach(e => e.style.pointerEvents = "none");
  split.chars.forEach((c) => (c.style.pointerEvents = "none"));
  element.style.pointerEvents = "auto";

  const chars = direction === "right" ? split.chars.reverse() : split.chars;
  const startColor = getComputedStyle(chars[0]).color;
  const staggerTime = 0.01;
  const offsetX = direction === "right" ? 500 : -500;

  chars.forEach((char, i) => {
    const tl = gsap.timeline({ delay: i * staggerTime });
    tl.fromTo(
      char,
      { textAlign: direction },
      {
        delay,
        rotationX: 180,
        rotationY: 180,
        scale: 1.2,
        transformOrigin: "50% 50%",
        ease: "expoScale",
        yoyo: true,
        repeat: 1,
        color: "#ECA6E9",
        duration: 0.06,
        ease: "power1.inOut",
      }
    ).to(char, {
      color: startColor,
      x: offsetX,
      opacity: 0,
      duration: 0.06,
      ease: "power1.inOut",
    });
  });
}

function getRandomMixedLanguageString(minLength = 5, maxLength = 20) {
  const allChars = (
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ" + 
    "абвгдеёжзийклмнопрстуфхцчшщъыьэюяАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ" + 
    "αβγδεζηθικλμνξοπρστυφχψωΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ" + 
    "áéíóúñüçøåäöèêîôûëÿœæß" + 
    "★☆♠♣♥♦♪♫☯⚛!@#$%^&*()-_=+[]{}<>?/|~"
  ).split("");

  const length =
    Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;
  let result = "";

  for (let i = 0; i < length; i++) {
    result += allChars[Math.floor(Math.random() * allChars.length)];
  }
  return result;
}

function decodeHTMLEntities(str) {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
}

function scrambleText({
  target,
  newText,
  duration = 1.5,
  characterSet = "абвгдеёжзийклмнопрстуфхцчшщъыьэюяΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ",
  frameRate = 30,
}) {
  const el =
    typeof target === "string" ? document.querySelector(target) : target;
  if (!el) return;

  // --- EDITOR MODE: Simple text swap ---
  if (isShopifyEditor()) {
    el.textContent = decodeHTMLEntities(newText);
    return;
  }
  // -------------------------------------

  const decodedText = decodeHTMLEntities(newText);
  const scrambleChars = characterSet.split("");
  const maxLength = Math.max(el.textContent.length, decodedText.length);
  const perCharDuration = duration / maxLength;

  const split = SplitText.create(el, { type: "chars" });
  const chars = split.chars;

  while (chars.length < maxLength) {
    const span = document.createElement("span");
    span.textContent = " ";
    el.appendChild(span);
    chars.push(span);
  }

  const tl = gsap.timeline();

  chars.forEach((char, i) => {
    const finalChar = decodedText[i] || " ";
    const fakeTextArray = [];

    for (let j = 0; j < frameRate * perCharDuration; j++) {
      fakeTextArray.push(
        scrambleChars[Math.floor(Math.random() * scrambleChars.length)]
      );
    }
    fakeTextArray.push(finalChar); 

    tl.to(
      char,
      {
        duration: perCharDuration,
        text: {
          value: fakeTextArray.join(""),
          delimiter: "",
        },
        ease: "none",
        onStart: () => char.classList.add("scrambling"),
        onComplete: () => {
          char.textContent = finalChar;
          char.classList.remove("scrambling");
        },
      },
      i * perCharDuration
    );
  });

  tl.eventCallback("onComplete", () => {
    split.revert();
    el.textContent = decodedText;
  });
}

var Modernizr = window.Modernizr || {
  prefixed: function (prop) { return prop; },
  cssanimations: true,
};

var classie = {
  add: function (el, cn) { el.classList.add(cn); },
  remove: function (el, cn) { el.classList.remove(cn); },
  has: function (el, cn) { return el.classList.contains(cn); },
};

(function (window) {
  "use strict";

  var support = { animations: Modernizr.cssanimations },
    animEndEventNames = {
      WebkitAnimation: "webkitAnimationEnd",
      OAnimation: "oAnimationEnd",
      msAnimation: "MSAnimationEnd",
      animation: "animationend",
    },
    animEndEventName = animEndEventNames[Modernizr.prefixed("animation")],
    onEndAnimation = function (el, callback) {
      var onEndCallbackFn = function (ev) {
        if (support.animations) {
          if (ev.target !== this) return;
          this.removeEventListener(animEndEventName, onEndCallbackFn);
        }
        if (callback && typeof callback === "function") {
          callback.call();
        }
      };
      if (support.animations) {
        el.addEventListener(animEndEventName, onEndCallbackFn);
      } else {
        onEndCallbackFn();
      }
    };

  function extend(a, b) {
    for (var key in b) {
      if (b.hasOwnProperty(key)) {
        a[key] = b[key];
      }
    }
    return a;
  }

  function MLMenu(el, options) {
    this.el = el;
    this.options = extend({}, this.options);
    extend(this.options, options);
    this.menus = [].slice.call(this.el.querySelectorAll(".menu__level"));
    this.current = 0;
    this._init();
  }

  MLMenu.prototype.options = {
    breadcrumbsCtrl: true,
    initialBreadcrumb: "All",
    backCtrl: true,
    itemsDelayInterval: 60,
    direction: "r2l",
    onItemClick: function (ev, itemName) {
      return false;
    },
  };

  MLMenu.prototype._init = function () {
    var self = this;

    this.menusArr = this.menus.map(function (menuEl, pos) {
      var menu = {
        menuEl: menuEl,
        menuItems: [].slice.call(menuEl.querySelectorAll(".menu__item")),
      };
      if (pos === self.current) {
        classie.add(menuEl, "menu__level--current");
      }
      return menu;
    });

    if (this.options.backCtrl) {
      this.backCtrl = document.querySelectorAll(".bot-menu-back")[0];
    }

    if (this.options.breadcrumbsCtrl) {
      this.breadcrumbsCtrl = document.createElement("nav");
      this.breadcrumbsCtrl.className = "menu__breadcrumbs";
      this.el.insertBefore(this.breadcrumbsCtrl, this.el.firstChild);
      this._addBreadcrumb(0);
    }

    // --- FIX FOR PROBLEM 2: STATE RESTORATION ---
    // (This logic needs to run in BOTH Admin and Live modes)
    const currentPath = window.location.pathname.replace(/\/$/, "");
    const currentLink = this.el.querySelector(
      `.menu__link[href="${currentPath}"]`
    );

    if (currentLink) {
      currentLink.classList.add("menu__link--current");

      const leafMenu = currentLink.closest(".menu__level");
      
      if (leafMenu) {
        let currentNode = leafMenu;
        const breadcrumbIndices = [];

        // Traverse UP
        while (currentNode) {
            const menuId = currentNode.getAttribute("data-menu");
            if (!menuId) break; 

            const parentLink = this.el.querySelector(`.menu__link[data-submenu="${menuId}"]`);
            if (!parentLink) break; 

            const parentItem = parentLink.closest(".menu__item");
            if (parentItem) {
                parentItem.classList.add("menu__item--active-ancestor");
            }

            const parentMenuEl = parentItem.closest(".menu__level");
            if(!parentMenuEl) break;

            const parentMenuIdx = this.menus.indexOf(parentMenuEl);
            const currentMenuIdx = this.menus.indexOf(currentNode);
            
            this.menusArr[currentMenuIdx].backIdx = parentMenuIdx;
            this.menusArr[currentMenuIdx].name = parentLink.textContent.trim();
            
            breadcrumbIndices.push(currentMenuIdx);
            currentNode = parentMenuEl;
        }

        // Apply state
        const leafIdx = this.menus.indexOf(leafMenu);
        if (leafIdx !== -1 && leafIdx !== 0) {
            classie.remove(this.menusArr[0].menuEl, "menu__level--current");
            classie.add(leafMenu, "menu__level--current");
            this.current = leafIdx;

            if (this.options.breadcrumbsCtrl) {
                breadcrumbIndices.reverse().forEach(idx => self._addBreadcrumb(idx));
            }
            if (this.backCtrl) classie.remove(this.backCtrl, "hidden");
        }
      }
    }
    // ---------------------------------------------

    this._initEvents();
  };

  MLMenu.prototype._initEvents = function () {
    var self = this;
    this.menusArr.forEach(function (menuObj, pos) {
      menuObj.menuItems.forEach(function (item, idx) {
        var link = item.querySelector("a");
        link.addEventListener("click", function (ev) {
          
          // --- FIX FOR PROBLEM 1: ADMIN CLICKS ---
          // Always stop propagation to keep Shopify Editor happy
          ev.stopPropagation(); 
          // ---------------------------------------

          var submenuKey = link.getAttribute("data-submenu"),
            subMenuEl = submenuKey
              ? self.el.querySelector('ul[data-menu="' + submenuKey + '"]')
              : null;
          if (submenuKey && subMenuEl) {
            ev.preventDefault();
            self.menusArr[self.menus.indexOf(subMenuEl)].backIdx = self.current;
            self.menusArr[self.menus.indexOf(subMenuEl)].name =
              link.textContent.trim();
            self._openSubMenu(subMenuEl, idx);
          } else {
            var cur = self.el.querySelector(".menu__link--current");
            if (cur) classie.remove(cur, "menu__link--current");
            classie.add(link, "menu__link--current");
            self.options.onItemClick(ev, link.innerHTML);
          }
        });
      });
    });

    if (this.backCtrl) {
      this.backCtrl.addEventListener("click", function (ev) {
        ev.stopPropagation();
        self._back();
      });
    }
  };

  MLMenu.prototype._openSubMenu = function (nextEl, clickPos) {
    if (this.isAnimating) return;
    
    // In admin, we don't block clicks with isAnimating flag
    // because we don't have animations to wait for.
    if (!isShopifyEditor()) {
        this.isAnimating = true;
    }
    
    this._menuOut(clickPos);
    this._menuIn(nextEl, clickPos);
  };

  MLMenu.prototype._back = function () {
    if (this.isAnimating) return;
    
    if (!isShopifyEditor()) {
        this.isAnimating = true;
    }

    var backMenu = this.menusArr[this.menusArr[this.current].backIdx].menuEl;
    this._menuOut();
    this._menuIn(backMenu);
    if (this.options.breadcrumbsCtrl) {
      this.breadcrumbsCtrl.removeChild(this.breadcrumbsCtrl.lastElementChild);
    }
  };

  MLMenu.prototype._menuOut = function (clickPos) {
    var self = this,
      curr = this.menusArr[this.current].menuEl,
      isBack = typeof clickPos === "undefined";

    // --- EDITOR MODE: BYPASS ANIMATION ---
    if (isShopifyEditor()) {
        classie.remove(curr, "menu__level--current");
        // No animation logic here, return early
        return;
    }
    // -------------------------------------

    this.menusArr[this.current].menuItems.forEach(function (item, i) {
      var d = isBack
        ? i * self.options.itemsDelayInterval
        : Math.abs(clickPos - i) * self.options.itemsDelayInterval;
      item.style.WebkitAnimationDelay = item.style.animationDelay = d + "ms";
      hideText(
        item.getElementsByTagName("a")[0],
        d / 1000 / 2,
        isBack ? "left" : "right"
      );
    });
    var cls = !isBack ? "animate-outToLeft" : "animate-outToRight";
    if (this.options.direction !== "r2l") {
      cls = isBack ? "animate-outToLeft" : "animate-outToRight";
    }
    classie.add(curr, cls);
  };

  MLMenu.prototype._menuIn = function (nextMenuEl, clickPosition) {
    var self = this,
      currentMenu = this.menusArr[this.current].menuEl,
      isBackNavigation = typeof clickPosition === "undefined",
      nextMenuIdx = this.menus.indexOf(nextMenuEl),
      nextMenuItems = this.menusArr[nextMenuIdx].menuItems,
      nextMenuItemsTotal = nextMenuItems.length;

    // --- EDITOR MODE: BYPASS ANIMATION (INSTANT SWITCH) ---
    if (isShopifyEditor()) {
        // Just swap the classes immediately
        classie.remove(currentMenu, "menu__level--current");
        classie.add(nextMenuEl, "menu__level--current");
        self.current = nextMenuIdx;

        if (!isBackNavigation) {
            if (self.backCtrl) classie.remove(self.backCtrl, "hidden");
            self._addBreadcrumb(nextMenuIdx);
        } else if (self.current === 0 && self.backCtrl) {
            classie.add(self.backCtrl, "hidden");
        }
        return;
    }
    // ------------------------------------------------------

    // Standard GSAP/CSS Animation Logic for Live Site
    classie.remove(nextMenuEl, "animate-inFromLeft");
    classie.remove(nextMenuEl, "animate-inFromRight");

    nextMenuItems.forEach(function (item) {
      item.style.opacity = "0";
    });

    void nextMenuEl.offsetWidth;

    nextMenuItems.forEach(function (item, pos) {
      var delay = isBackNavigation
        ? pos * self.options.itemsDelayInterval
        : Math.abs(clickPosition - pos) * self.options.itemsDelayInterval;

      item.style.WebkitAnimationDelay = item.style.animationDelay =
        delay + "ms";

      showText(
        item.getElementsByTagName("a")[0],
        delay / 1000 + 0.2,
        isBackNavigation ? "left" : "right"
      );

      var farthestIdx =
        clickPosition <= nextMenuItemsTotal / 2 || isBackNavigation
          ? nextMenuItemsTotal - 1
          : 0;

      if (pos === farthestIdx) {
        onEndAnimation(item, function () {
          if (self.options.direction === "r2l") {
            classie.remove(
              currentMenu,
              !isBackNavigation ? "animate-outToLeft" : "animate-outToRight"
            );
            classie.remove(
              nextMenuEl,
              !isBackNavigation ? "animate-inFromRight" : "animate-inFromLeft"
            );
          } else {
            classie.remove(
              currentMenu,
              isBackNavigation ? "animate-outToLeft" : "animate-outToRight"
            );
            classie.remove(
              nextMenuEl,
              isBackNavigation ? "animate-inFromRight" : "animate-inFromLeft"
            );
          }

          nextMenuItems.forEach(function (itm) {
            itm.style.WebkitAnimationDelay = "";
            itm.style.animationDelay = "";
            itm.style.opacity = "";
          });

          classie.remove(currentMenu, "menu__level--current");
          classie.add(nextMenuEl, "menu__level--current");
          self.current = nextMenuIdx;

          if (!isBackNavigation) {
            if (self.backCtrl) classie.remove(self.backCtrl, "hidden");
            self._addBreadcrumb(nextMenuIdx);
          } else if (self.current === 0 && self.backCtrl) {
            classie.add(self.backCtrl, "hidden");
          }

          self.isAnimating = false;
        });
      }
    });

    if (this.options.direction === "r2l") {
      classie.add(
        nextMenuEl,
        isBackNavigation ? "animate-inFromLeft" : "animate-inFromRight"
      );
    } else {
      classie.add(
        nextMenuEl,
        isBackNavigation ? "animate-inFromRight" : "animate-inFromLeft"
      );
    }
  };

  MLMenu.prototype._addBreadcrumb = function (idx) {
    var bc = document.createElement("a");
    bc.href = "#";
    var inner = document.createElement("span");
    inner.className = "breadcrumb-text";
    bc.appendChild(inner);
    this.breadcrumbsCtrl.appendChild(bc);

    scrambleText({
      target: inner,
      newText: idx ? this.menusArr[idx].name : this.options.initialBreadcrumb,
      characterSet: getRandomMixedLanguageString(0, 55),
      duration: 1,
      frameRate: 20,
    });

    var self = this;
    bc.addEventListener("click", function (ev) {
      ev.preventDefault();
      // Keep propagation stop
      ev.stopPropagation(); 
      if (!bc.nextSibling || self.isAnimating) return;
      
      // Admin bypass for animating flag
      if (!isShopifyEditor()) self.isAnimating = true;
      
      self._menuOut();
      self._menuIn(self.menusArr[idx].menuEl);
      var sib;
      while ((sib = bc.nextSibling)) {
        self.breadcrumbsCtrl.removeChild(sib);
      }
    });
  };

  window.MLMenu = MLMenu;
})(window);